import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import { CONSUMER_COMPLAINT } from "tagTypes";

export const useConsumerComplaintsQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/consumer-complaint",
    query,
    tags: [CONSUMER_COMPLAINT],
  });

export const useLazyConsumerComplaintsQuery = () => {
  const [getConsumerComplaint, data] = useLazyGetQuery();
  const consumerComplaint = async (query = {}) =>
    await getConsumerComplaint(
      {
        endpoint: "/consumer-complaint",
        query,
        tags: [CONSUMER_COMPLAINT],
      },
      true
    ).unwrap();
  return [consumerComplaint, data];
};

export const useGetNoOfConsumerComplaintsQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/report/consumer-complaint",
    query,
    tags: [CONSUMER_COMPLAINT],
  });

export const useLazyNoOfConsumerComplaintsQuery = () => {
  const [getNoOfConsumerComplaints, data] = useLazyGetQuery();
  const fetchNoOfConsumerComplaints = async (query = {}) =>
    await getNoOfConsumerComplaints(
      {
        endpoint: "/report/consumer-complaint",
        query,
        tags: [CONSUMER_COMPLAINT],
      },
      true
    ).unwrap();
  return [fetchNoOfConsumerComplaints, data];
};

export const useLazyConsumerAllComplaintsQuery = () => {
  const [getConsumerAllComplaint, data] = useLazyGetQuery();
  const consumerAllComplaint = async (query = {}) =>
    await getConsumerAllComplaint(
      {
        endpoint: "/user/consumer-complaint",
        query,
        tags: [CONSUMER_COMPLAINT],
      },
      true
    ).unwrap();
  return [consumerAllComplaint, data];
};

export const useConsumerComplaintQuery = (id, query = {}) =>
  useGetQuery({
    endpoint: `/consumer-complaint/${id}`,
    query,
    tags: [CONSUMER_COMPLAINT],
  });

export const useLazyConsumerComplaintQuery = () => {
  const [getConsumerComplaint, data] = useLazyGetQuery();
  const consumerComplaint = async (id, query = {}) =>
    await getConsumerComplaint(
      {
        endpoint: `/consumer-complaint/${id}`,
        query,
        tags: [CONSUMER_COMPLAINT],
      },
      true
    ).unwrap();
  return [consumerComplaint, data];
};

export const useConsumerComplaintByUtilityConsumerIdQuery = (id, query = {}) =>
  useGetQuery({
    endpoint: `/utilityConsumer/${id}/consumer-complaint`,
    query,
    tags: [CONSUMER_COMPLAINT],
  });

export const useLazyConsumerComplaintByUtilityConsumerIdQuery = () => {
  const [getUtilityConsumerComplaint, data] = useLazyGetQuery();
  const utilityConsumerComplaint = async (id, query = {}) =>
    await getUtilityConsumerComplaint(
      {
        endpoint: `/utilityConsumer/${id}/consumer-complaint`,
        query,
        tags: [CONSUMER_COMPLAINT],
      },
      true
    ).unwrap();
  return [utilityConsumerComplaint, data];
};

export const usePostConsumerComplaintMutation = () => {
  const [addComplaint, data] = usePostMutation();
  const complaint = async (payload, query = {}) =>
    await addComplaint({
      endpoint: "/consumer-complaint",
      query,
      payload: payload || {},
      toastMessage: "Consumer complaint added successfully",
      tags: [CONSUMER_COMPLAINT],
    }).unwrap();
  return [complaint, data];
};

export const usePutConsumerComplaintMutation = () => {
  const [updateComplaint, data] = usePutMutation();
  const complaint = async (payload, id, query = {}) =>
    await updateComplaint({
      endpoint: `/consumer-complaint/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Consumer complaint updated successfully",
      tags: [CONSUMER_COMPLAINT],
    }).unwrap();
  return [complaint, data];
};
